var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedHalfCircle = function SvgRedHalfCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 226 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.228 51.2688C392.636 51.2688 406.52 84.4216 406.52 108.507V111.908C406.52 135.993 393.77 167.162 321.228 167.162H154.341C81.7981 167.162 69.0482 135.993 69.0482 111.908V108.507C69.0482 84.4216 82.9321 51.2684 154.341 51.2684H321.228L321.228 51.2688ZM154.515 0H148.56C15.026 0 0 68.2318 0 105.321V113.813C0 151.468 15.0264 218 148.56 218H327.44C460.974 218 476 151.468 476 113.813V105.32C476 68.2318 460.974 0 327.44 0H154.515Z",
    fill: "#D5001C"
  })));
};
export default SvgRedHalfCircle;